import { render, staticRenderFns } from "./SidebarHistoryVersions.vue?vue&type=template&id=a165347e&"
import script from "./SidebarHistoryVersions.vue?vue&type=script&lang=js&"
export * from "./SidebarHistoryVersions.vue?vue&type=script&lang=js&"
import style0 from "./SidebarHistoryVersions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports